<div class="grid md:grid-cols-3 sm:grid-cols-1 gap-2">
  @if (allowBranchSelection()) {
    <div [class.hidden]="branchSelector.children.length === 0" [class.col-span-1]="branchSelector.children.length > 0" #branchSelector>
      <ng-content select="[branchSelect]"></ng-content>
    </div>

    @if (branchSelector.children.length === 0) {
      <div class="col-span-1">
        <app-page-select-branch
          [(selected)]="selectedBranches"
          [label]="branchSelectionLabel()"
          [multi]="branchSelectionMulti()"
          [autoSelectDefaultBranch]="branchSelectionSelectDefault()"
          [autoSelectBranchIds]="branchSelectionAutoSelectBranchIds()"
          [disabled]="branchSelectionDisabled()"
          [showIncidentIcon]="showIncidentIcon()"
          [showExternalId]="branchSelectionShowExternalId()"
          [overrideBranches]="branchOverrideBranches()"
          [branchRequestParams]="branchRequestParams()"
          [branchFilterFn]="branchFilterFn()"
          [doNaturalSort]="doNaturalSort()"
          (defaultSelected)="branchDefaultSelected.emit($event)"
        ></app-page-select-branch>
      </div>
    }
  }

  @if (allowLocationSelection()) {
    <div
      [class.hidden]="locationSelector.children.length === 0"
      [class.col-span-1]="locationSelector.children.length > 0"
      #locationSelector
    >
      <ng-content select="[locationSelect]"></ng-content>
    </div>

    @if (locationSelector.children.length === 0) {
      <div class="col-span-1">
        <app-page-select-location
          [(selected)]="selectedLocations"
          [label]="locationSelectionLabel()"
          [multi]="locationSelectionMulti()"
          [autoSelectDefaultLocation]="locationSelectionSelectDefault()"
          [autoSelectLocationIds]="locationSelectionAutoSelectLocationIds()"
          [disabled]="locationSelectionDisabled()"
          [overrideLocations]="locationOverrideLocations()"
          [forceShowOverrideLocationsEvenIfEmpty]="locationForceShowOverrideLocationsEvenIfEmpty()"
          [showBranchName]="locationShowBranchName()"
          [locationFilterFn]="locationFilterFn()"
          (defaultSelected)="locationDefaultSelected.emit($event)"
        ></app-page-select-location>
      </div>
    }
  }

  @if (allowLocationGroupSelection()) {
    <div
      [class.hidden]="locationGroupSelector.children.length === 0"
      [class.col-span-1]="locationGroupSelector.children.length > 0"
      #locationGroupSelector
    >
      <ng-content select="[locationGroupSelect]"></ng-content>
    </div>

    @if (locationGroupSelector.children.length === 0) {
      <div class="col-span-1">
        <app-page-select-location-group
          [(selected)]="selectedLocationGroups"
          [label]="locationGroupSelectionLabel()"
          [multi]="locationGroupSelectionMulti()"
          [autoSelectDefaultLocationGroup]="locationGroupSelectionSelectDefault()"
          [autoSelectLocationGroupIds]="locationGroupSelectionAutoSelectLocationIds()"
          [disabled]="locationGroupSelectionDisabled()"
          [showExternalId]="locationGroupSelectionShowExternalId()"
          [overrideLocationGroups]="locationGroupOverrideLocations()"
          (defaultSelected)="locationGroupDefaultSelected.emit($event)"
        ></app-page-select-location-group>
      </div>
    }
  }
</div>

@if (allowDateRangeSelection()) {
  <div class="grid md:grid-cols-5 sm:grid-cols-1 gap-2">
    <div
      [class.hidden]="dateRangeStartSelector.children.length === 0"
      [class.col-span-1]="dateRangeStartSelector.children.length > 0"
      #dateRangeStartSelector
    >
      <ng-content select="[dateRangeStart]"></ng-content>
    </div>

    @if (dateRangeStartSelector.children.length === 0) {
      <div class="col-span-1 flex gap-2 items-baseline">
        <app-pan-form-control>
          <app-pan-floating-label> {{ dateRangeStartLabel() }} </app-pan-floating-label>
          <app-pan-datepicker
            [(date)]="dateRangeStart"
            [disabled]="dateRangeStartDisabled()"
            [min]="dateRangeStartMin()"
            [max]="dateRangeEnd()"
            placeholder="Select date from"
          />
        </app-pan-form-control>

        @if (dateRangeShowClear()) {
          <app-pan-button (click)="dateRangeStart.set(undefined)" [disabled]="dateRangeStartDisabled()">Clear</app-pan-button>
        }
      </div>
    }

    <div
      [class.hidden]="dateRangeEndSelector.children.length === 0"
      [class.col-span-1]="dateRangeEndSelector.children.length > 0"
      #dateRangeEndSelector
    >
      <ng-content select="[dateRangeEnd]"></ng-content>
    </div>

    @if (dateRangeEndSelector.children.length === 0) {
      <div class="col-span-1 flex gap-2 items-baseline">
        <app-pan-form-control>
          <app-pan-floating-label> {{ dateRangeEndLabel() }} </app-pan-floating-label>
          <app-pan-datepicker
            [(date)]="dateRangeEnd"
            [disabled]="dateRangeEndDisabled()"
            [min]="dateRangeStart()"
            [max]="dateRangeEndMax()"
            placeholder="Select date from"
          />
        </app-pan-form-control>

        @if (dateRangeShowClear()) {
          <app-pan-button (click)="dateRangeEnd.set(undefined)" [disabled]="dateRangeEndDisabled()">Clear</app-pan-button>
        }
      </div>
    }
  </div>
}

<div>
  <ng-content select="[body]"></ng-content>
</div>
